// extracted by mini-css-extract-plugin
module.exports = {"Breakpoints":"Breakpoints_Breakpoints__cf8Ii","List":"Breakpoints_List__0IDmq","Empty":"Breakpoints_Empty__W5sAA"};